import { Injector, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dynamicPipe',
    standalone: true
})
export class DynamicPipe implements PipeTransform {
    public constructor(private _injector: Injector) {}

    transform(value: unknown, pipeToken: unknown, pipeArgs: unknown[]): unknown {
        if (!pipeToken) {
            return value;
        } else {
            const pipe = this._injector.get(pipeToken);
            return pipe.transform(value, ...pipeArgs);
        }
    }
}
